
import {
  Form,
  Input,
  Checkbox,
  Button,
  FormItem,
  Select,
  Option,
  CollapseTransition,
  OptionGroup,
} from 'element-ui';
import { ChevronDownIcon } from 'vue-feather-icons';
import { AddressHelpers } from '@/helpers/AddressHelpers';
import addressMixin from '@/mixins/addressMixin';

export default {
  props: {
    idAddress: {
      type: String | Number,
      default: null,
    },
    short: {
      type: Boolean,
      default: false,
    },
    cancelButton: {
      type: Boolean,
      default: true,
    },
  },
  mixins: [addressMixin],
  data() {
    this.setCustomerConected();
    return {
      customer: null,
      openAdd: false,
      showAddressLine2: false,
      addressInfo: {
        Alias: '',
        Lastname: this.customer?.Lastname,
        Firstname: this.customer?.Firstname,
        Address1: '',
        Address2: '',
        Postcode: '',
        City: '',
        StateName: '',
        StateCode: '',
        StateIsoCode: '',
        CountryIsoCode: '',
        Country: '',
        MobilePhoneCode: '+33',
        MobilePhone: '',
        PhoneCode: '+33',
        Phone: '',
        Company: '',
        IsInvoice: true,
        IsDelivery: true,
      },
      rules: {
        Lastname: [
          {
            required: true,
            message: this.$t('Required Field'),
            trigger: 'blur',
          },
        ],
        Firstname: [
          {
            required: true,
            message: this.$t('Required Field'),
            trigger: 'blur',
          },
        ],
        Address1: [
          {
            required: true,
            message: this.$t('Required Field'),
            trigger: 'blur',
          },
        ],
        Address2: [
          // {
          //   required: true,
          //   message: this.$t('Required Field'),
          //   trigger: "blur",
          // },
        ],
        Postcode: [
          {
            required: true,
            message: this.$t('Required Field'),
            trigger: 'blur',
          },
        ],
        City: [
          {
            required: true,
            message: this.$t('Required Field'),
            trigger: 'blur',
          },
        ],
        CountryIsoCode: [
          {
            required: true,
            message: this.$t('Required Field'),
            trigger: ['blur', 'change'],
          },
        ],
        MobilePhone: [
          {
            required: true,
            message: this.$t('Required Field'),
            trigger: 'blur',
          },
        ],
        // Phone: [
        //   {
        //     required: true,
        //     message: this.$t('Required Field'),
        //     trigger: "blur",
        //   },
        // ],
      },
      phoneCodes: [
        { code: '+33', label: '+33 (France)' },
        { code: '+1', label: '+1 (USA/Canada)' },
        { code: '+44', label: '+44 (UK)' },
        { code: '+49', label: '+49 (Germany)' },
        { code: '+34', label: '+34 (Spain)' },
        { code: '+39', label: '+39 (Italy)' },
        { code: '+32', label: '+32 (Belgium)' },
        { code: '+41', label: '+41 (Switzerland)' },
        { code: '+351', label: '+351 (Portugal)' },
        { code: '+31', label: '+31 (Netherlands)' },
        { code: '+352', label: '+352 (Luxembourg)' },
        { code: '+212', label: '+212 (Morocco)' },
        { code: '+213', label: '+213 (Algeria)' },
        { code: '+216', label: '+216 (Tunisia)' },
      ],
      clientCountry: null,
    };
  },
  watch: {
    'addressInfo.CountryIsoCode': {
      handler(val) {
        if (!val) {
          this.addressInfo.Country = '';
          return;
        }
        const found = this.countries.find((c) => c.CountryIsoCode === val);
        if (found) {
          this.addressInfo.Country = found.CountryName;
        }
      },
      immediate: true,
    },
  },
  computed: {
    countries() {
      return this.$localisation.countries;
    },
    getClientCountry() {
      return this.$localisation.countries.find(
        (country) => country?.CountryIsoCode === this.clientCountry?.country
      );
    },
  },
  async mounted() {
    // if (this.address != null) {
    //   this.addressInfo = this.address;
    // }
    try {
      await this.loadClientCountryIsoCode();
    } catch (error) {}

    if (process.client) {
      if (this.$route.hash === '#mobilephone') {
        const field = this.$refs?.mobilePhone.$el.querySelector('input');

        field.focus();

        this.scrollTo(field);
      }
    }

    if (this.idAddress) {
      const listAddress = this.$store.state.address.List;

      if (listAddress.length === 0) {
        await this.getAddresses();
      }
      const idAddress = this.idAddress;
      const address = this.$store.state.address.List.filter((item) => {
        return Number(item.IdAddress) === Number(idAddress);
      })[0];

      // Process the address to extract phone codes if they exist
      const processedAddress = { ...address };

      // Extract mobile phone code if it exists
      if (processedAddress.MobilePhone) {
        const mobileMatch = processedAddress.MobilePhone.split(' ');
        if (mobileMatch.length === 2) {
          processedAddress.MobilePhoneCode = mobileMatch[0];
          processedAddress.MobilePhone = mobileMatch[1];
        } else if (mobileMatch.length === 1) {
          processedAddress.MobilePhone = mobileMatch[0];
          processedAddress.MobilePhoneCode = '+33'; // Default code
        }
      }

      // Extract phone code if it exists
      if (processedAddress.Phone) {
        const phoneMatch = processedAddress.Phone.split(' ');
        if (phoneMatch.length === 2) {
          processedAddress.PhoneCode = phoneMatch[0];
          processedAddress.Phone = phoneMatch[1];
        } else if (phoneMatch.length === 1) {
          processedAddress.Phone = phoneMatch[0];
          processedAddress.PhoneCode = '+33'; // Default code
        }
      }

      this.addressInfo = { ...processedAddress };
    } else {
      this.addressInfo.CountryIsoCode =
        this.getClientCountry?.CountryIsoCode || '';
    }
    setTimeout(() => {
      this.openAdd = true;
    }, 100);
  },
  methods: {
    // addresAutoCompleteTextChange($event) {
    //   this.addressInfo.Address1 = $event.text;
    // },

    scrollTo(element) {
      const y = element.getBoundingClientRect().top + window.scrollY - 160; // Added 80px offset for better visibility
      window.scrollTo({
        top: y,
        behavior: 'smooth',
      });
    },
    setCustomerConected() {
      let userGuest = this.$store.state.user.guest.guestUser;

      if (this.$auth.loggedIn) {
        this.customer = this.$auth.user.Customer;
      } else if (userGuest) {
        this.customer = userGuest;
      }
    },
    getListAddresses() {
      const list = this.$store.state.address.List;
      return list;
    },
    async submitForm() {
      // Format phone numbers with country code before validation and submission
      // if (this.addressInfo.MobilePhone && this.addressInfo.MobilePhoneCode) {
      //   // Remove leading zero if present
      //   let mobilePhone = this.addressInfo.MobilePhone;
      //   if (mobilePhone.startsWith('0')) {
      //     mobilePhone = mobilePhone.substring(1);
      //   }
      //   this.addressInfo.MobilePhone = `${this.addressInfo.MobilePhoneCode} ${mobilePhone}`;
      // }

      // if (this.addressInfo.Phone && this.addressInfo.PhoneCode) {
      //   // Remove leading zero if present
      //   let phone = this.addressInfo.Phone;
      //   if (phone.startsWith('0')) {
      //     phone = phone.substring(1);
      //   }
      //   this.addressInfo.Phone = `${this.addressInfo.PhoneCode} ${phone}`;
      // }

      this.$refs['AddressForm'].validate(async (valid) => {
        if (valid) {
          if (this.idAddress) {
            await this.updateAddress(this.idAddress);
          } else {
            await this.createAddress();
          }
        } else {
          // Find the first field with error and scroll to it
          this.$nextTick(() => {
            const errorField = document.querySelector('.el-form-item.is-error');
            if (errorField) {
              this.scrollTo(errorField);
              // Focus on the first input element within the error field
              const inputElement = errorField.querySelector(
                'input, textarea, select'
              );
              if (inputElement) {
                inputElement.focus();
              }
            }
          });
          return false;
        }
      });
    },

    async createAddress() {
      this.addressService
        .add(this.addressInfo)
        .then((data) => {
          this.addressService.fetchAddresses({
            onSuccess: () => {
              this.$emit('onSubmit', data);
            },
          });
        })
        .catch((err) => {});
    },

    updateAddress(idAddress) {
      this.addressService
        .update(idAddress, this.addressInfo)
        .then((data) => {
          this.addressService.fetchAddresses({
            onSuccess: () => {
              this.$emit('onSubmit', data);
            },
          });
        })
        .catch((err) => {});
    },

    onSelectAddress($event) {
      // const words = $event.formatted_address.split(",");
      // this.addressInfo.Address1 = "";
      // if (words.length) {
      // }

      this.addressInfo.Address1 = $event.courtAddress;

      this.getCountrySlected($event.country);

      this.addressInfo.Country = $event.country ? $event.country : '';
      this.addressInfo.City = $event.city ? $event.city : '';
      this.addressInfo.Postcode = $event.postalCode ? $event.postalCode : '';
      this.addressInfo.StateName = $event.StateName ? $event.StateName : '';
      this.addressInfo.StateCode = $event.StateCode ? $event.StateCode : '';
      this.addressInfo.StateIsoCode = $event.StateIsoCode
        ? $event.StateIsoCode
        : '';
    },

    onAddressTextChange(e) {
      this.addressInfo.Address1 = e.text;
    },

    onStateNameChange() {
      this.addressInfo.StateCode = '';
      this.addressInfo.StateIsoCode = '';
    },

    getCountrySlected(country) {
      if (country) {
        const country_selected = this.countries.find(
          (item) => item.CountryName?.toLowerCase() === country?.toLowerCase()
        );
        if (country_selected) {
          this.addressInfo.CountryIsoCode = country_selected.CountryIsoCode;
        } else {
          this.addressInfo.CountryIsoCode = '';
        }
      } else {
        this.addressInfo.CountryIsoCode = '';
      }
    },

    async getAddresses() {
      const addressHelpers = new AddressHelpers(this.$http, this.$store);
      await addressHelpers.getList();
    },

    async loadClientCountryIsoCode() {
      try {
        const res = await this.$axios.$get('/api/visitor');
        // Example output: { ip: "8.8.8.8", country: "US" }
        this.clientCountry = res;
      } catch (e) {
        console.error('Failed to fetch visitor info', e);
      }
    },
  },
  components: {
    Form,
    Input,
    Checkbox,
    Button,
    FormItem,
    Select,
    Option,
    OptionGroup,
    CollapseTransition,
    ChevronDownIcon,
  },
};
